<template>
    <!-- Hero row for a request's identity: the title is the primary element, the year and the
         period sit opposite it as compact metadata so the row is used edge to edge instead of
         leaving the line half empty. Shared by every procedure's detail view. -->
    <div v-if="hasContent" class="rsh">
        <div class="rsh-main">
            <div class="rsh-label">{{ $t('RequestTitle') }}</div>
            <h3 class="rsh-title">{{ title || '—' }}</h3>
        </div>

        <div v-if="year || period" class="rsh-meta">
            <span v-if="year" class="rsh-chip">
                <v-icon class="rsh-chip-ic">mdi-calendar-blank-outline</v-icon>
                <span class="rsh-chip-txt">
                    <span class="rsh-chip-lbl">{{ $t('RequestYear') }}</span>
                    <span class="rsh-chip-val">{{ year }}</span>
                </span>
            </span>

            <span v-if="period" class="rsh-chip">
                <v-icon class="rsh-chip-ic">mdi-timelapse</v-icon>
                <span class="rsh-chip-txt">
                    <span class="rsh-chip-lbl">{{ $t('Period') }}</span>
                    <span class="rsh-chip-val">{{ $t('Period' + period) }}</span>
                </span>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: { type: String, default: '' },
            year: { type: [String, Number], default: null },
            period: { type: String, default: '' }
        },

        computed: {
            // requests submitted before these fields existed carry none of them — render nothing
            hasContent() {
                return !!(this.title || this.year || this.period)
            }
        }
    }
</script>

<style scoped>
    .rsh {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 14px 20px;
        background: #f4f9f6;
        border: 1px solid #d3ebe0;
        border-inline-start: 4px solid #1B8354;
        border-radius: 10px;
        padding: 14px 18px;
        margin-bottom: 22px;
    }

    .rsh-main { min-width: 0; flex: 1 1 260px; }

    .rsh-label {
        font-size: 11.5px;
        font-weight: 700;
        letter-spacing: .07em;
        text-transform: uppercase;
        color: #94a3b0;
        margin-bottom: 3px;
    }

    .rsh-title {
        font-size: 21px;
        font-weight: 700;
        line-height: 1.35;
        color: #22323d;
        margin: 0;
        overflow-wrap: anywhere;
    }

    .rsh-meta {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        flex: 0 1 auto;
    }

    .rsh-chip {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #fff;
        border: 1px solid #d3ebe0;
        border-radius: 9px;
        padding: 7px 12px;
    }

    .rsh-chip-ic {
        font-size: 17px !important;
        color: #1B8354 !important;
    }

    .rsh-chip-txt { display: flex; flex-direction: column; line-height: 1.25; }
    .rsh-chip-lbl { font-size: 11px; font-weight: 600; color: #94a3b0; }
    .rsh-chip-val { font-size: 14.5px; font-weight: 700; color: #22323d; white-space: nowrap; }

    /* stack on narrow screens so nothing is squeezed */
    @media (max-width: 599px) {
        .rsh { align-items: flex-start; padding: 13px 15px; }
        .rsh-title { font-size: 18.5px; }
        .rsh-meta { width: 100%; }
        .rsh-chip { flex: 1 1 auto; }
    }
</style>
